<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" :title="payFlag ? '支付' : '微信授权'" />
    </van-sticky>
    <div v-if="payFlag" class="block">
      <!-- 当前信息 -->
      <!-- {{ payOrder }} -->
      <div class="font-bigger">订单信息</div>
      <van-form class="mt10">
        <van-field
          disabled
          v-model="payOrder.subject"
          label="标题"
        />
        <van-field
          disabled
          v-model="payOrder.outTradeNo"
          label="订单号"
        />
        <van-field
          disabled
          v-model="payOrder.amount"
          label="金额"
        />
      </van-form>
      <div style="margin: 16px;">
        <van-button @click="onSubmit" round block type="primary" native-type="submit" color="#ff9e19">
          立即支付
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios"
import { Toast } from 'vant'
import Filter from "../../../../utils/filter"
import { pay } from '../../../../api/testing-record'
import { wechatLogin } from '../../../../api/login'
import { wechatBind } from '../../../../api/user'
import UserInfoForm from '@/components/UserInfo'
export default {
  data() {
    return {
      payFlag: false,
      payOrder: {},
      formData: {}
    };
  },
  components: {
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    onClickLeft() {
      history.back()
    },
    onSubmit() {
      this.onBridgeReady(JSON.parse(this.payOrder.payJson))
    },
    toOld() {
      // 去老版
      // location.href = 'https://kpapi.kpjkgl.com/H5/#/homePage'
      var sign = this.$md5(localStorage.getItem('tel') + 'kangping').substring(8, 24)
      console.info(sign)
      axios({
          method: 'post',
          url: 'https://ai.kpjkgl.com:444/userLogin/loginAllow?userId='+ localStorage.getItem('tel') +'&md5Tag='+ sign +'&channelName=kangping'
      })
      .then(response => {
        console.info(response)
        if (response.data.code == 200) {
          var data = response.data.data
          location.href = 'https://kpapi.kpjkgl.com/H5/#/login?userId=' + data.userId + '&role=' + data.role + '&allow=' + data.allow
        } else{
          // 提示语
          Toast(response.data.msg)
        }
      })
    },
    onBridgeReady(data) {
      var that = this
      console.info(data)
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
            "appId": data.appId,     //公众号ID，由商户传入
            "timeStamp": data.timeStamp + "",     //时间戳，自1970年以来的秒数
            "nonceStr": data.nonceStr,      //随机串
            "package": data.package1,
            "signType": data.signType,     //微信签名方式：
            "paySign": data.sign //微信签名
        },
        (res) => {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              if (that.payOrder.type.key == 'Testing') {
                if (localStorage.getItem('testingId') == 7 || localStorage.getItem('testingId') == '7') {
                  // 跳转
                  that.toOld()
                } else {
                  // 成功，跳转
                  this.$router.push({
                    path: '/testing-info',
                    query: {
                      testingId: localStorage.getItem('testingId'),
                      testingRecordId: this.payOrder.relationId
                    }
                  })
                }
              } else {
                this.$router.push({
                  path: '/mine',
                  query: {
                  }
                })
              }
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            }
        })
    },
    getQueryString: function(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(decodeURI(r[2]))
      return null
    },
    async init() {
      // var code = this.$route.query.code
      // 根据state，处理
      if (this.getQueryString('state') === 'login') {
        this.payFlag = false
        // 登录操作
        wechatLogin({
          code: this.getQueryString('code'),
          state: this.getQueryString('state')
        }).then(res => {
          Toast('登录成功')
          localStorage.setItem('reload', true)
          localStorage.setItem('Token', res.token)
          localStorage.setItem('UserId', res.userId)
          localStorage.setItem('TokenLogin', false)
          // 跳转
          setTimeout(() => {
            if (localStorage.getItem('welcome-url')) {
              location.href = localStorage.getItem('welcome-url')
            } else {
              this.$router.push({
                path: '/mine'
              })
            }
          }, 1000)
        })
      } else if (this.getQueryString('state') === 'bind') {
        // 绑定微信
        this.payFlag = false
        wechatBind({
          code: this.getQueryString('code'),
          state: this.getQueryString('state')
        }).then(res => {
          Toast('绑定成功')
          // 跳转
          setTimeout(() => {
            this.$router.push({
              path: '/mine'
            })
          }, 1000)
        })
      } else {
        this.payFlag = true
        // 请求
        pay({
          code: this.getQueryString('code'),
          state: this.getQueryString('state')
        }).then(res => {
          this.payOrder = res
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/style.css');
.block {
  margin-top: 40px;
  padding: 0 40px;
}
</style>